

<script>
  import { onMount } from "svelte";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import Toaster from './Toaster.svelte';

  import backend from "../../../../../server";
  export let campaign;  
  export let isModalGame =false ;

  let isLoading = false;
  let showAlert = false;
  let type = false; 
  let isShowToast =false;
  let toastMessage='';
  let message = []; 
  let isDelete = {}; 

 let game={currency:'USD',bet_amount:'',game_ids:[]}
 let selectedIds = []; 
 let filterAmount = '';
  const closeModal = () => {
      isModalGame = false;  
  };


  const validateCampaign = () => {
    let isValid = true;
    game.game_ids = selectedIds;
    
    let numericAmount = parseFloat(filterAmount);
    game.bet_amount = !isNaN(numericAmount) && numericAmount > 0 ? numericAmount : game.bet_amount;

    if (game.bet_amount <= 0) {
      toastMessage = "Debes especificar un monto válido para aceptado por los proveedores.";
      isValid = false;
    }

    if (game.game_ids.length === 0) {
      toastMessage = 'Seleccione al menos un juego.';
      isValid = false;
    }

    return { isValid, toastMessage };
};


  const saveGames = async () => {
    var { isValid, toastMessage } = validateCampaign();
    if (!isValid) {
      isShowToast= true
      return;
    }
    try {
      isLoading = true;
      let response = await backend.freespin.saveAddGamesCampaign(game, campaign.id);
      message = response.data.messages.length > 0 ? response.data.messages : ['Games were successfully added.']
      type = (response.data.status) ? true: false;

      if(response.data.status){
        getCampaignById(campaign.id)
        selectedIds = []; 
        isShowToast= true
      }


  } catch (error) {
    console.error('Error:', error.message);
  } finally {

  isLoading = false;
  showAlert = true;
}
};

  onMount(async () => {

          await getCampaignById(campaign.id);
          
      });



 $:if(filterAmount !==''){selectedIds=[]}


let games = [
  
  {"id":1042478,"name":"Diamond Magic Deluxe 1034867-NBC","product_bet_amounts":[0.1,0.2,0.3,0.4,0.5,1,1.5,3,6,10,25,50,100]},
  {"id":1013274,"name":"Wild Marmalade (Wild Dolphin 1032061-NBC)","product_bet_amounts":[0.1,0.2,0.3,0.4,0.5,1,1.5,3,6,10,25,50,100]},
  {"id":1013276,"name":"Blackjack – Side Bets (Lady Luck  1030281-NBC)","product_bet_amounts":[0.2,0.4,0.6,0.8,1,2,3,6,12,20,50,100]},
  {"id":1013279,"name":"Wild Wild Fruit (Gold Of Ra  1022211-NBC)","product_bet_amounts":[0.25,0.5,0.75,1,1.25,2.5,5,12.5,25,50,100]},
  {"id":1013280,"name":"Surfin' Joker (Dancing Lions 1021476-NBC)","product_bet_amounts":[0.1,0.2,0.3,0.4,0.5,1,1.5,3,6,10,25,50,100]},
  {"id":1013281,"name":"Xtreme Summer Hot (Phoenix Princess  1021316-NBC)","product_bet_amounts":[0.2,0.4,0.6,0.8,1,2,3,6,12,20,50,100]},
  {"id":1013283,"name":"Sevens and Diamonds (Magic Unicorn  1021086-NBC)","product_bet_amounts":[0.5,1,1.5,2,2.5,5,10,25,50,100]}
 
  ];

  const removeProduct = async (product_bet_amount_id) => {

    try {
      isDelete[product_bet_amount_id] = true;
      let response = await backend.freespin.removeProductByBetAmountId({id :campaign.id ,productId: product_bet_amount_id});
    
      if(response.data.status){
        getCampaignById(campaign.id)
      }
      type = true
      toastMessage= 'Players were successfully added.';
      isShowToast = true
    } catch (error) {
      
      toastMessage=error.message
     
    } finally {
      isDelete[product_bet_amount_id] = false;
  
}
};

const getCampaignById = async (campaignId) => {
  try {
    console.log("Campaign ID:", campaignId);
    let response = await backend.freespin.getCampaignById(campaignId);

    // Verifica toda la estructura de 'response.data'
    console.log("Estructura completa de Response Data:", response.data);

    // Verifica que 'status' sea verdadero y que 'data' contenga productos
    if (response.data && response.data.status && response.data.data) {
      campaign.products = response.data.data.products;

      
    } else {
      console.log("La respuesta no contiene datos válidos.");
    }
  } catch (error) {
    console.log("Error:", error.message);
    toastMessage = error.message; // Si tienes un sistema de notificaciones
  }
}




const handleRowClick =(id) =>{
  selectedIds = selectedIds.includes(id) ?
  selectedIds.filter(item => item !== id) : [...selectedIds, id];
}

</script>
<Modal isOpen={isModalGame} toggle={closeModal} size="xl">
  <ModalHeader toggle={closeModal}>
    Agregar Juegos en la campaña {campaign.client_campaign_title}
  </ModalHeader>
  <ModalBody>

   

    <div class="alert alert-warning alert-dismissible fade show" role="alert" style="margin-top: 20px; margin-bottom: 20px;">
      <strong>Condiciones para agregar juegos a una campaña: La campaña debe estar en el estado "Programada". <br>
        Si la campaña seleccionada no está en ese estado, no podrás agregar productos.</strong>
    </div>
    
 

    <table class="table table-sm" style="width: 100%;">
      <thead style="background-color:rgb(79 61 58); color: white;">
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>
            Montos
            <!-- Filtro de monto -->
            <input 
              type="number" 
              placeholder="monto 0.2..." 
              bind:value={filterAmount} 
              style="margin-left: 10px; width: 120px;  border-radius: 5px;"  step="any"
            />
          </th>
          <th style="text-align: center;">Seleccionado</th>
        </tr>
      </thead>
      <tbody>
        {#each games as game}
          {#if !filterAmount || game.product_bet_amounts.some(amount => amount === parseFloat(filterAmount))}
            <tr 
              on:click={() => handleRowClick(game.id)} 
              class:selected={selectedIds.includes(game.id)}
              style="cursor: pointer;">
              <td>{game.id}</td>
              <td>{game.name}</td>
              <td>
                {#if Array.isArray(game?.product_bet_amounts) && game.product_bet_amounts.length > 0}
                  {#each game.product_bet_amounts.sort((a, b) => a - b) as amount}
                    <span class="badge bg-secondary" style="margin-right: 5px;">{amount}</span>
                  {/each}
                {:else}
                  <span>No bet amounts available</span>
                {/if}
              </td>
              <td style="text-align: center;">
                <span>{selectedIds.includes(game.id) ? '✔️' : ''}</span>
              </td>
            </tr>
          {/if}
        {/each}
      </tbody>
      
    </table>

    <table class="table table-sm" style="width: 100%;">
      <thead style="background-color:rgb(79 61 58); color: white;">
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>Montos</th>
          <th>Moneda</th>
          <th>Fecha de Creación</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {#if campaign?.products && campaign.products.length > 0}
          {#each campaign.products as product}
            <tr>
              <td>{product.product_id}</td>
              <td>{product.product_name}</td>
              <td>{product.amount}</td>
              <td>{product.currency}</td>
              <td>{new Date(product.created_at.date).toLocaleString()}</td>
              <td>
                <div class="button-container">
                  <button
                    on:click={() => removeProduct(product.product_bet_amount_id)}  
                    class="btn btn-danger btn-sm" 
                    disabled={isDelete[product.product_bet_amount_id]}
                  >
                    {#if isDelete[product.product_bet_amount_id]}
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Cargando...
                    {:else}
                      <i class="fa-solid fa-trash"></i> 
                    {/if}
                  </button>
                </div>
              </td>
            </tr>
          {/each}
        {:else}
          <tr>
            <td colspan="6" class="no-products-message">La campaña no tiene productos agregados</td>
          </tr>
        {/if}
      </tbody>
    </table>
    

    {#if showAlert}
    <div class={`alert alert-${type ? 'success' : 'danger'} alert-dismissible fade show`} role="alert">
        <strong>{type ? '¡Éxito!' : '¡Error!'}</strong>
        {#each message as msg}
        <li>{msg}</li>
        {/each}
        <button type="button" class="btn-close" on:click={() => showAlert = false}></button>
    </div>
    {/if}
    
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-primary" on:click={saveGames} disabled={isLoading}>
      {#if isLoading}
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Cargando...
      {:else}
        Guardar
      {/if}
    </button>
  </ModalFooter>
</Modal>

<Toaster  bind:message={toastMessage} bind:type={type} bind:show={isShowToast} />

<style>
   table {
    border-collapse: collapse;
    width: 100%;
  }

  .table-sm {
    font-size: 0.9rem;
  }

/* Estilo para la fila seleccionada */
.selected {
  background-color: #c4c4c8; /* Color de fondo para la fila seleccionada */
}
  
</style>